import { Button } from '@box/blueprint-web';
import {
  Notification,
  NotificationsWrapper,
} from 'box-ui-elements/es/components/notification';
import React from 'react';
// @ts-expect-error [MIGRATION-SUPPRESSION]: TS1484
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import messages from './messages';

type BuieFormErrorNotificationProps = {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  errorMessage: any;
  intl: IntlShape;
  onClose: () => void;
};

const BuieFormErrorNotification = ({
  onClose,
  errorMessage,
  intl,
}: BuieFormErrorNotificationProps) => {
  const displayButton =
    errorMessage && errorMessage.values && errorMessage.values.info;

  // BUIE NotificationsWrapper & Notification don't accept the data-testid
  return (
    <NotificationsWrapper>
      <Notification duration="short" onClose={onClose} type="error">
        <span>
          <FormattedMessage {...errorMessage} />
        </span>
        {displayButton && (
          <Button
            onClick={() =>
              window.open(errorMessage.values.info, '_blank', 'noreferrer')
            }
            size="small"
            variant="outline"
          >
            {intl.formatMessage(messages.infoButtonLabel)}
          </Button>
        )}
      </Notification>
    </NotificationsWrapper>
  );
};

export default injectIntl(BuieFormErrorNotification);
